<template>
  <v-container>
    <v-card-title>
      <span class="headline">Import Videos</span>
    </v-card-title>

    <import-videos-component></import-videos-component>

  </v-container>
</template>

<script>

import ImportVideosComponent from '../components/ImportVideos.vue';

export default {
  name: 'ImportVideos',
  components: {
    ImportVideosComponent,
  },
};
</script>
